import React, { useState } from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { Grid, TextField, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { ITripPlannerValues } from '../types/locationTypes';
import plannerYellowBorderSlice from '../../../store/modules/plannerYellowBorderSlice';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';

const useStyles = makeStyles((theme) => ({
    textFieldInput: {
        width: "105%",
        height: "30px",
        textAlign: "center",
        borderColor: "#ECECEC",
        '& input': {
            textAlign: "center",
            fontSize: 14,
        },
    },
}));

interface PlannerShiftHoursRowProps {
    parentClasses: ClassNameMap,
    title: any,
    values: any,
    planner: ITripPlannerValues,
    planners: ITripPlannerValues[],
    setPlanners: any,
    setUpdate: any,
    readonly: boolean,
    order: number
}

const PlannerShiftHoursRow: React.FC<PlannerShiftHoursRowProps> = ({
    parentClasses,
    title,
    values,
    planner,
    planners,
    setPlanners,
    setUpdate,
    readonly,
    order
}) => {
    var monValue:ParsableDate=null;
    var tueValue:ParsableDate=null;
    var wedValue:ParsableDate=null;
    var thuValue:ParsableDate=null;
    var friValue:ParsableDate=null;
    var satValue:ParsableDate=null;
    var sunValue:ParsableDate=null;

    React.useEffect(() => {
        if (values){
            monValue=convertToTime(values.mon);
            tueValue=convertToTime(values.tue);
            wedValue=convertToTime(values.wed);
            thuValue=convertToTime(values.thu);
            friValue=convertToTime(values.fri);
            satValue=convertToTime(values.sat);
            sunValue=convertToTime(values.sun);
        }
    }, [values]);
    const classes = useStyles();
    const convertToTime = (timeString :string|null) =>{
        if (timeString!=null){
            if(!checkTimeIsValid(timeString))
            return timeString;
            else{
            const _hours = new Date();
            _hours.setHours(parseInt(timeString.split(":")[0]), parseInt(timeString.split(":")[1]), 0, 0);
            return _hours;
        }
        }
        else return null;
    }
    const checkTimeIsValid =(time:string) : boolean=>{
        if (time.split(":").length!=2)
        return false;
        if(isNaN(time.split(":")[0] as any))
        return false;
        if(isNaN(time.split(":")[1] as any))
        return false;
        if(parseInt(time.split(":")[0])>23 || parseInt(time.split(":")[0])<0)
        return false; 
        if(parseInt(time.split(":")[1])>59 || parseInt(time.split(":")[1])<0)
        return false;
        return true;
      }
    const updatePlanner = (date:string,value:string|any,title:string,field:string) => {
        let newPlanner = {...planner};
        let newPlanners = [...planners];
        let index = newPlanners.findIndex((x) => x.tripPlannerId === newPlanner.tripPlannerId);
        if (!isNaN(Date.parse(date))){
            var mainPlanner=planners.filter(p => {return p.tripPlannerId==planner.tripPlannerId});
            if (index !== -1 && newPlanners[index]) {
                switch(title){
                    case "Shift Start Time":
                        switch(field){
                            case "mon":
                                newPlanner.monFrom = parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.monFromString=value;
                                break;
                            case "tue":
                                newPlanner.tueFrom=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.tueFromString=value;
                                break;
                            case "wed":
                                newPlanner.wedFrom=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.wedFromString=value;
                                break;
                            case "thur":
                                newPlanner.thurFrom=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.thurFromString=value;
                                break;
                            case "fri":
                                newPlanner.friFrom=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.friFromString=value;
                                break;
                            case "sat":
                                newPlanner.satFrom=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.satFromString=value;
                                break;
                            case "sun":
                                newPlanner.sunFrom=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.sunFromString=value;
                                break;      
                        }
                        break;
                    case "Shift End Time":
                        switch(field){
                            case "mon":
                                newPlanner.monTo=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.monToString=value;
                                break;
                            case "tue":
                                newPlanner.tueTo=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.tueToString=value;
                                break;
                            case "wed":
                                newPlanner.wedTo=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.wedToString=value;
                                break;
                            case "thur":
                                newPlanner.thurTo=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.thurToString=value;
                                break;
                            case "fri":
                                newPlanner.friTo=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.friToString=value;
                                break;
                            case "sat":
                                newPlanner.satTo=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.satToString=value;
                                break;
                            case "sun":
                                newPlanner.sunTo=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.sunToString=value;
                                break;
                        }
                        break;
                    case "Break Start Time":
                        switch(field){
                            case "mon":
                                newPlanner.breakStartMon=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.breakStartMonString=value;
                                break;
                            case "tue":
                                newPlanner.breakStartTue=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.breakStartTueString=value;
                                break;
                            case "wed":
                                newPlanner.breakStartWed=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.breakStartWedString=value;
                                break;
                            case "thur":
                                newPlanner.breakStartThu=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.breakStartThuString=value;
                                break;
                            case "fri":
                                newPlanner.breakStartFri=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.breakStartFriString=value;
                                break;
                            case "sat":
                                newPlanner.breakStartSat=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.breakStartSatString=value;
                                break;
                            case "sun":
                                newPlanner.breakStartSun=parseInt(value.split(":")[0])*60+parseInt(value.split(":")[1]);
                                newPlanner.breakStartSunString=value;
                                break;
                        }
                    break;
                }
            }
        }
        else{
            switch(title){
                case "Shift Start Time":
                    switch(field){
                        case "mon":
                            newPlanner.monFrom=value?newPlanner.monFrom:null;
                            newPlanner.monFromString=value?value:"";
                            break;
                        case "tue":
                            newPlanner.tueFrom=value?newPlanner.tueFrom:null;
                            newPlanner.tueFromString=value?value:"";
                            break;
                        case "wed":
                            newPlanner.wedFrom=value?newPlanner.wedFrom:null;
                            newPlanner.wedFromString=value?value:"";
                            break;
                        case "thur":
                            newPlanner.thurFrom=value?newPlanner.thurFrom:null;
                            newPlanner.thurFromString=value?value:"";
                            break;
                        case "fri":
                            newPlanner.friFrom=value?newPlanner.friFrom:null;
                            newPlanner.friFromString=value?value:"";
                            break;
                        case "sat":
                            newPlanner.satFrom=value?newPlanner.satFrom:null;
                            newPlanner.satFromString=value?value:"";
                            break;
                        case "sun":
                            newPlanner.sunFrom=value?newPlanner.sunFrom:null;
                            newPlanner.sunFromString=value?value:"";
                            break;      
                    }
                    break;
                case "Shift End Time":
                    switch(field){
                        case "mon":
                            newPlanner.monTo=value?newPlanner.monTo:null;
                            newPlanner.monToString=value?value:"";
                            break;
                        case "tue":
                            newPlanner.tueTo=value?newPlanner.tueTo:null;
                            newPlanner.tueToString=value?value:"";
                            break;
                        case "wed":
                            newPlanner.wedTo=value?newPlanner.wedTo:null;
                            newPlanner.wedToString=value?value:"";
                            break;
                        case "thur":
                            newPlanner.thurTo=value?newPlanner.thurTo:null;
                            newPlanner.thurToString=value?value:"";
                            break;
                        case "fri":
                            newPlanner.friTo=value?newPlanner.friTo:null;
                            newPlanner.friToString=value?value:"";
                            break;
                        case "sat":
                            newPlanner.satTo=value?newPlanner.satTo:null;
                            newPlanner.satToString=value?value:"";
                            break;
                        case "sun":
                            newPlanner.sunTo=value?newPlanner.sunTo:null;
                            newPlanner.sunToString=value?value:"";
                            break;
                    }
                    break;
                case "Break Start Time":
                    switch(field){
                        case "mon":
                            newPlanner.breakStartMon=value?newPlanner.breakStartMon:null;
                            newPlanner.breakStartMonString=value?value:"";
                            break;
                        case "tue":
                            newPlanner.breakStartTue=value?newPlanner.breakStartTue:null;
                            newPlanner.breakStartTueString=value?value:"";
                            break;
                        case "wed":
                            newPlanner.breakStartWed=value?newPlanner.breakStartWed:null;
                            newPlanner.breakStartWedString=value?value:"";
                            break;
                        case "thur":
                            newPlanner.breakStartThu=value?newPlanner.breakStartThu:null;
                            newPlanner.breakStartThuString=value?value:"";
                            break;
                        case "fri":
                            newPlanner.breakStartFri=value?newPlanner.breakStartFri:null;
                            newPlanner.breakStartFriString=value?value:"";
                            break;
                        case "sat":
                            newPlanner.breakStartSat=value?newPlanner.breakStartSat:null;
                            newPlanner.breakStartSatString=value?value:"";
                            break;
                        case "sun":
                            newPlanner.breakStartSun=value?newPlanner.breakStartSun:null;
                            newPlanner.breakStartSunString=value?value:"";
                            break;
                    }
                break;
            }
        }
        newPlanners[index]=newPlanner;
        setPlanners(newPlanners);
        setUpdate(true);
    }

    return (
        <>
        <div className={title=="Max Break Delay (Hrs)" ? parentClasses.inputRowWithoutBorder : parentClasses.inputRow}>
        <Grid container className={'shiftHourGrid body'}>
            <Grid item md={3}>
                <div className={"subTitle"}>
                    {title}
                </div>
            </Grid>
            <Grid item md={9} style={{flexBasis:'74.2%' }}>
                <Grid container className={"weekDayGrid"}>
                    <Grid item>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                value={values ? monValue: "" }
                                inputValue={values ? values.mon: "" }
                                onChange={(date, value) => {updatePlanner(date ? date?.toDateString() : "",value,title,"mon")}}
                                ampm={false}
                                invalidDateMessage="Invalid"
                                InputAdornmentProps={{
                                    style: { display: 'none' }
                                }}
                                InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order}
                                        }}
                                error={false}
                                helperText={''}
                                inputVariant='outlined'
                                //disabled={false}
                                mask="__:__"
                                disabled={readonly}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                value={values ? tueValue: "" }
                                onChange={(date, value) => {updatePlanner(date ? date?.toDateString() : "",value,title,"tue")}}
                                ampm={false}
                                invalidDateMessage="Invalid"
                                InputAdornmentProps={{
                                    style: { display: 'none' }
                                }}
                                InputProps={{ classes: { root: classes.textFieldInput },
                                inputProps:{tabIndex:order+5}
                                }}
                                error={false}
                                helperText={''}
                                inputVariant='outlined'
                                //disabled={false}
                                mask="__:__"
                                disabled={readonly}
                                inputValue={values ? values.tue :""}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                value={values ? wedValue: "" }
                                onChange={(date, value) => {updatePlanner(date ? date?.toDateString() : "",value,title,"wed")}}
                                ampm={false}
                                invalidDateMessage="Invalid"
                                InputAdornmentProps={{
                                    style: { display: 'none' }
                                }}
                                InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order+10}
                                        }}
                                error={false}
                                helperText={''}
                                inputVariant='outlined'
                                //disabled={false}
                                mask="__:__"
                                disabled={readonly}
                                inputValue={values ? values.wed: "" }
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                value={values ? thuValue: "" }
                                onChange={(date, value) => {updatePlanner(date ? date?.toDateString() : "",value,title,"thur")}}
                                ampm={false}
                                invalidDateMessage="Invalid"
                                InputAdornmentProps={{
                                    style: { display: 'none' }
                                }}
                                InputProps={{ classes: { root: classes.textFieldInput },
                                    inputProps:{tabIndex:order+15}
                                }}
                                error={false}
                                helperText={''}
                                inputVariant='outlined'
                                //disabled={false}
                                mask="__:__"
                                disabled={readonly}
                                inputValue={values ? values.thu: "" }
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                value={values ? friValue: "" }
                                onChange={(date, value) => {updatePlanner(date ? date?.toDateString() : "",value,title,"fri")}}
                                ampm={false}
                                invalidDateMessage="Invalid"
                                InputAdornmentProps={{
                                    style: { display: 'none' }
                                }}
                                InputProps={{ classes: { root: classes.textFieldInput },
                                inputProps:{tabIndex:order+20}
                                }}
                                error={false}
                                helperText={''}
                                inputVariant='outlined'
                                //disabled={false}
                                mask="__:__"
                                disabled={readonly}
                                inputValue={values ? values.fri: "" }
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                value={values ? satValue: "" }
                                onChange={(date, value) => {updatePlanner(date ? date?.toDateString() : "",value,title,"sat")}}
                                ampm={false}
                                invalidDateMessage="Invalid"
                                InputAdornmentProps={{
                                    style: { display: 'none' }
                                }}
                                InputProps={{ classes: { root: classes.textFieldInput },
                                        inputProps:{tabIndex:order+25}
                                        }}
                                error={false}
                                helperText={''}
                                inputVariant='outlined'
                                //disabled={false}
                                mask="__:__"
                                disabled={readonly}
                                inputValue={values ? values.sat: "" }
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                value={values ? sunValue: "" }
                                onChange={(date, value) => {updatePlanner(date ? date?.toDateString() : "",value,title,"sun")}}
                                ampm={false}
                                invalidDateMessage="Invalid"
                                InputAdornmentProps={{
                                    style: { display: 'none' }
                                }}
                                InputProps={{ classes: { root: classes.textFieldInput },
                                inputProps:{tabIndex:order+30}
                                }}
                                error={false}
                                helperText={''}
                                inputVariant='outlined'
                                //disabled={false}
                                mask="__:__"
                                disabled={readonly}
                                inputValue={values ? values.sun: "" }
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        </div>
        </>
    );
}

export default PlannerShiftHoursRow;